import { IManagedPosition, IPositionQueue, IQueue, IUserQueue, IUserWithQueue } from "@/Settings/types/QueueMapping/QueueMapping";
import QueueMappingDetails from "./QueueMappingDetails";

interface IQueueMappingBodyProps {
	queueLabels: string[] | null;
	isQueueLabelsLoading: boolean;
	queues: IQueue[] | null;
	managedPositions: string[] | null;
	selectedPositions: IManagedPosition[] | null;
	onPositionsChange: (selected: IManagedPosition[]) => void;
	queue: IQueue;
	handleQueueName: (title: string) => void;
	handleUpdateOverflowQueues: (overflowQueues: string[]) => void;
	associates: IUserWithQueue[] | null;
	employees: IUserWithQueue[] | null;
	isPositionsLoading: boolean;
	isEmployeesLoading: boolean;
	isUsersLoading: boolean;
	selectedUsers: IPositionQueue[];
	onAssociatesChange: (selected: IUserWithQueue[]) => void;
	onEmployeesChange: (selected: IUserWithQueue[]) => void;
	onDeletePosition: (positionId: string) => void;
	onDeleteMembers: (usersToRemove: IPositionQueue[]) => void;
	handleSelectUser: (position: string, user: IUserQueue) => void;
	uniqueUsers: string[];
}
const QueueMappingBody = (props: IQueueMappingBodyProps) => {
	const {
		queueLabels,
		isQueueLabelsLoading,
		queues,
		managedPositions,
		selectedPositions,
		onPositionsChange,
		queue,
		handleQueueName,
		handleUpdateOverflowQueues,
		associates,
		employees,
		isPositionsLoading,
		isEmployeesLoading,
		isUsersLoading,
		selectedUsers,
		onAssociatesChange,
		onEmployeesChange,
		onDeletePosition,
		onDeleteMembers,
		handleSelectUser,
		uniqueUsers,
	} = props;

	return (
		<QueueMappingDetails
			queueLabels={queueLabels ?? []}
			isQueueLabelsLoading={isQueueLabelsLoading}
			queues={queues ?? []}
			managedPositions={managedPositions ?? []}
			selectedPositions={selectedPositions ?? []}
			onPositionsChange={onPositionsChange}
			queue={queue}
			handleQueueName={handleQueueName}
			handleUpdateOverflowQueues={handleUpdateOverflowQueues}
			associates={associates ?? []}
			employees={employees ?? []}
			isPositionsLoading={isPositionsLoading}
			isEmployeesLoading={isEmployeesLoading}
			isUsersLoading={isUsersLoading}
			selectedUsers={selectedUsers}
			onAssociatesChange={onAssociatesChange}
			onEmployeesChange={onEmployeesChange}
			onDeletePosition={onDeletePosition}
			onDeleteMembers={onDeleteMembers}
			handleSelectUser={handleSelectUser}
			uniqueUsers={uniqueUsers}
		/>
	);
};

export default QueueMappingBody;
